

 <div
 class="flex flex-column justify-center align-center h-100 text-center family-info"
 style="height: 500px;"
>
 

<ng-container *ngIf="page == 'selection'">
    <h1 class="para-title sorry__title">
  
        <p>
          Select loan amount
        </p>
     </h1>
    
     
    
     <div
       class="ui grid justify-center "
       style="overflow: hidden; margin: 0 auto; cursor: pointer; z-index: 30;"
       
     >
       <div
         (click)="selectAnOffer(teacherOffer)"
         class="twelve wide column myborder mt-3 addFlexBehavior"
         *ngFor="let teacherOffer of offersFromCreditClan; index as i"
       >
         <div class="bolded">
           
           <div class="loan_information">

            <span class="housing_for_loan_amount">  Loan: <span class="loan_amount"> ₦{{ teacherOffer?.principal }} </span>  </span>
            <span class="housing_for_loan_amount">  Duration: <span class="loan_amount"> {{teacherOffer?.duration }} month </span>  </span>
           </div>
           
           
           
          </div>
        
         
    
       </div>
    
      
    
      
    
    
       <!-- <button [disabled]="selectedOffer == undefined" (click)="page = 'card_tokenisation'"  class="ui button primary basic">
         Continue
       </button> -->
     </div>
</ng-container>


<ng-container *ngIf="page == 'address'">
    <h1 class="para-title">Please enter your residential address</h1>
    <div
    class="w-100 text-center family-info"
      
       
     >
    <app-address-form
      (doneAddingAddress)="receivedAddress($event)"
    ></app-address-form>
    </div>
</ng-container>

<ng-container *ngIf="page == 'offer'">
    <h1 class="para-title">
       Summary of Offer
    </h1>

  
    <div style="width: 100%">
      <div class="ui fluid vertical menu">
        <a  class=" item flexed"  style="font-weight: bold;">
          Amount
          <div class="ui ">₦{{selectedOffer?.principal}}</div>
        </a>
        <a class="item flexed" style="font-weight: bold;">
          Duration
          <div class="ui "> {{selectedOffer?.duration}} months</div>
        </a>
        <a class="item flexed" style="font-weight: bold;">
          Monthly
          <div class="ui ">₦{{selectedOffer?.monthly_amount}}</div>
        </a>

        <a class="item flexed" style="font-weight: bold;">
          First Repayment
          <div class="ui "> {{ selectedOffer?.first_repayment_date | date}} </div>
        </a>
        
    </div>

      <button  (click)="endOfLoanApplicationProcess()"   class="ui button primary basic">
        <i *ngIf="submittingOffer" class="fa fa-circle-notch fa-spin"></i>  Accept
      </button>
    </div>
        
  
</ng-container>
 
</div> 
